import moment from 'moment';
<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        title="Opmerkingen"
        :large="true"
        :addClose="true"
        @close="close"
        :icon="messageIcon"
    >
      <slot name="load">

      </slot>
      <b-table responsive striped hover :fields="fields" :items="data" show-empty primary-key="id"
               thead-tr-class="headRow" tbody-tr-class="tableRow" emptyText="Geen resultaten">

      </b-table>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import {
    // SVG
   commentIcon,
    // COMPONENTS
    deanDialog,
  } from '@deanone/dean-components';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import { deanDialogBus } from '@/main';
  import axios from 'axios';
  import { messageIcon } from '@deanone/dean-components';
  import moment from 'moment';
  import {BTable} from 'bootstrap-vue';
  import {getDutchLongDateFormat} from "@/mixins/dateWrapper";

  @Component({
    components: {
      DeanNotification,
      deanDialog,
      deanButton,
      BTable,
    },
  })

  export default class ViewMessagesDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: any,
    };
    public data: any = [];
    public messageIcon: object = messageIcon;

    public fields = [
      {key: 'userName', label: 'Naam gebruiker'},
      {key: 'message', label: 'Opmerking'},
      {key: 'created', label: 'Datum'},
    ];

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public created() {
      this.$emit('setLoad', true);
      axios.post('/-/trade/api/order.line.comments', {
        id: this.$route.params.cpId,
      })
        .then(
        (response) => {
          this.data = response.data.data.map((comment: any) => {
            return {
              userName: comment.user.username,
              message: comment.message,
              created: getDutchLongDateFormat(comment.createdAt),
            };
          });
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveDataModal);
        },
      ).finally(() => {
        this.$emit('setLoad', false);
      });
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

</style>

